import React, { useState } from 'react';
import { OfficerLayout } from '../../components/layout/OfficerLayout';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Textarea } from '../../components/ui/Textarea';
import { Badge } from '../../components/ui/Badge';
import { Modal } from '../../components/ui/Modal';
import { Upload, Link as LinkIcon, Image as ImageIcon, Video, CheckCircle, Clock, XCircle, Plus, Eye, ExternalLink, Calendar, MapPin, FileText, Camera, Loader2, AlertCircle, ChevronRight } from 'lucide-react';
import { cn } from '../../lib/utils';
interface ProofItem {
  id: string;
  type: 'media_tayang' | 'dokumentasi' | 'screenshot';
  title: string;
  program: string;
  mediaType: string;
  url?: string;
  date: string;
  status: 'pending' | 'approved' | 'rejected';
  note?: string;
}
const mockProofs: ProofItem[] = [{
  id: '1',
  type: 'media_tayang',
  title: 'Tayang Poster HPSN di Videotron Bundaran HI',
  program: 'HPSN 2025',
  mediaType: 'Videotron',
  url: 'https://example.com/video1',
  date: '20 Feb 2025',
  status: 'approved'
}, {
  id: '2',
  type: 'dokumentasi',
  title: 'Dokumentasi Sosialisasi RT 05',
  program: 'Pilah Sampah',
  mediaType: 'Foto Kegiatan',
  date: '18 Feb 2025',
  status: 'approved'
}, {
  id: '3',
  type: 'screenshot',
  title: 'Screenshot Posting Instagram @dlh_jakarta',
  program: 'HPSN 2025',
  mediaType: 'Instagram',
  url: 'https://instagram.com/p/xxx',
  date: '21 Feb 2025',
  status: 'pending'
}, {
  id: '4',
  type: 'media_tayang',
  title: 'Tayang Iklan Radio Prambors',
  program: 'Cegah Sampah Plastik',
  mediaType: 'Radio',
  date: '15 Feb 2025',
  status: 'rejected',
  note: 'Bukti audio tidak jelas, mohon upload ulang dengan kualitas lebih baik'
}];
export function ProofOfPerformancePage() {
  const [activeTab, setActiveTab] = useState<'upload' | 'history'>('upload');
  const [proofType, setProofType] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [selectedProof, setSelectedProof] = useState<ProofItem | null>(null);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const handleSubmit = () => {
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'approved':
        return <Badge className="bg-green-100 text-green-700 border-green-200 gap-1" data-id="element-3613">
            <CheckCircle className="h-3 w-3" data-id="element-3614" /> Disetujui
          </Badge>;
      case 'pending':
        return <Badge className="bg-yellow-100 text-yellow-700 border-yellow-200 gap-1" data-id="element-3615">
            <Clock className="h-3 w-3" data-id="element-3616" /> Menunggu
          </Badge>;
      case 'rejected':
        return <Badge className="bg-red-100 text-red-700 border-red-200 gap-1" data-id="element-3617">
            <XCircle className="h-3 w-3" data-id="element-3618" /> Ditolak
          </Badge>;
      default:
        return null;
    }
  };
  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'media_tayang':
        return <Video className="h-5 w-5 text-purple-500" data-id="element-3619" />;
      case 'dokumentasi':
        return <Camera className="h-5 w-5 text-blue-500" data-id="element-3620" />;
      case 'screenshot':
        return <ImageIcon className="h-5 w-5 text-green-500" data-id="element-3621" />;
      default:
        return <FileText className="h-5 w-5 text-gray-500" data-id="element-3622" />;
    }
  };
  if (isSuccess) {
    return <OfficerLayout title="Bukti Berhasil Dikirim" data-id="element-3623">
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center animate-in zoom-in duration-300" data-id="element-3624">
          <div className="h-20 w-20 bg-green-100 rounded-full flex items-center justify-center text-green-600 mb-6" data-id="element-3625">
            <CheckCircle className="h-10 w-10" data-id="element-3626" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-3627">
            Bukti Terkirim!
          </h2>
          <p className="text-gray-600 mb-8 max-w-xs" data-id="element-3628">
            Bukti tayang/dokumentasi Anda telah dikirim dan akan direview oleh
            admin.
          </p>
          <div className="flex flex-col gap-3 w-full max-w-xs" data-id="element-3629">
            <Button className="w-full bg-primary-600 hover:bg-primary-700" onClick={() => {
            setIsSuccess(false);
            setProofType('');
            setUploadedFiles([]);
          }} data-id="element-3630">
              Upload Bukti Lain
            </Button>
            <Button variant="outline" onClick={() => setActiveTab('history')} data-id="element-3631">
              Lihat Riwayat
            </Button>
          </div>
        </div>
      </OfficerLayout>;
  }
  return <OfficerLayout title="Proof of Performance" data-id="element-3632">
      {/* Tabs */}
      <div className="flex p-1 bg-gray-100 rounded-lg mb-6" data-id="element-3633">
        <button className={cn('flex-1 py-2 text-sm font-medium rounded-md transition-all', activeTab === 'upload' ? 'bg-white shadow text-primary-600' : 'text-gray-500')} onClick={() => setActiveTab('upload')} data-id="element-3634">
          Upload Bukti
        </button>
        <button className={cn('flex-1 py-2 text-sm font-medium rounded-md transition-all', activeTab === 'history' ? 'bg-white shadow text-primary-600' : 'text-gray-500')} onClick={() => setActiveTab('history')} data-id="element-3635">
          Riwayat
        </button>
      </div>

      {activeTab === 'upload' ? <div className="space-y-6 animate-in fade-in duration-300" data-id="element-3636">
          {/* Info Card */}
          <Card className="bg-blue-50 border-blue-200" data-id="element-3637">
            <CardContent className="p-4 flex gap-3" data-id="element-3638">
              <AlertCircle className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-3639" />
              <div className="text-sm text-blue-800" data-id="element-3640">
                <p className="font-medium mb-1" data-id="element-3641">
                  Apa itu Proof of Performance?
                </p>
                <p className="text-blue-700" data-id="element-3642">
                  Upload bukti penayangan materi KIE di media (TV, radio,
                  videotron, medsos) atau dokumentasi kegiatan untuk verifikasi
                  dan pelaporan.
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Type Selection */}
          <div className="space-y-3" data-id="element-3643">
            <label className="text-sm font-medium text-gray-700" data-id="element-3644">
              Jenis Bukti <span className="text-red-500" data-id="element-3645">*</span>
            </label>
            <div className="grid grid-cols-1 gap-3" data-id="element-3646">
              {[{
            value: 'media_tayang',
            label: 'Bukti Tayang Media',
            desc: 'TV, Radio, Videotron, Billboard',
            icon: Video,
            color: 'purple'
          }, {
            value: 'screenshot',
            label: 'Screenshot Media Sosial',
            desc: 'Instagram, TikTok, Facebook, Twitter',
            icon: ImageIcon,
            color: 'green'
          }, {
            value: 'dokumentasi',
            label: 'Dokumentasi Kegiatan',
            desc: 'Foto/Video kegiatan sosialisasi',
            icon: Camera,
            color: 'blue'
          }].map(type => <button key={type.value} onClick={() => setProofType(type.value)} className={cn('flex items-center gap-4 p-4 rounded-lg border-2 text-left transition-all', proofType === type.value ? `border-${type.color}-500 bg-${type.color}-50` : 'border-gray-200 hover:border-gray-300')} data-id="element-3647">
                  <div className={`p-3 rounded-full bg-${type.color}-100`} data-id="element-3648">
                    <type.icon className={`h-6 w-6 text-${type.color}-600`} data-id="element-3649" />
                  </div>
                  <div className="flex-1" data-id="element-3650">
                    <p className="font-medium text-gray-900" data-id="element-3651">{type.label}</p>
                    <p className="text-xs text-gray-500" data-id="element-3652">{type.desc}</p>
                  </div>
                  <div className={cn('h-5 w-5 rounded-full border-2 flex items-center justify-center', proofType === type.value ? `border-${type.color}-500 bg-${type.color}-500` : 'border-gray-300')} data-id="element-3653">
                    {proofType === type.value && <CheckCircle className="h-4 w-4 text-white" data-id="element-3654" />}
                  </div>
                </button>)}
            </div>
          </div>

          {proofType && <div className="space-y-4 animate-in fade-in slide-in-from-bottom-4 duration-300" data-id="element-3655">
              {/* Program Selection */}
              <div className="space-y-2" data-id="element-3656">
                <label className="text-sm font-medium text-gray-700" data-id="element-3657">
                  Program Terkait <span className="text-red-500" data-id="element-3658">*</span>
                </label>
                <Select data-id="element-3659">
                  <option value="" data-id="element-3660">Pilih program...</option>
                  <option value="hpsn" data-id="element-3661">HPSN 2025</option>
                  <option value="pilah" data-id="element-3662">Pilah Sampah dari Rumah</option>
                  <option value="cegah" data-id="element-3663">Cegah Sampah Plastik</option>
                  <option value="other" data-id="element-3664">Kegiatan Rutin Lainnya</option>
                </Select>
              </div>

              {/* Title */}
              <div className="space-y-2" data-id="element-3665">
                <label className="text-sm font-medium text-gray-700" data-id="element-3666">
                  Judul/Deskripsi <span className="text-red-500" data-id="element-3667">*</span>
                </label>
                <Input placeholder="Contoh: Tayang Poster HPSN di Videotron Bundaran HI" data-id="element-3668" />
              </div>

              {/* Media Type */}
              {proofType === 'media_tayang' && <div className="space-y-2" data-id="element-3669">
                  <label className="text-sm font-medium text-gray-700" data-id="element-3670">
                    Jenis Media <span className="text-red-500" data-id="element-3671">*</span>
                  </label>
                  <Select data-id="element-3672">
                    <option value="" data-id="element-3673">Pilih jenis media...</option>
                    <option value="tv" data-id="element-3674">TV</option>
                    <option value="radio" data-id="element-3675">Radio</option>
                    <option value="videotron" data-id="element-3676">Videotron/LED</option>
                    <option value="billboard" data-id="element-3677">Billboard/Baliho</option>
                    <option value="other" data-id="element-3678">Lainnya</option>
                  </Select>
                </div>}

              {proofType === 'screenshot' && <div className="space-y-2" data-id="element-3679">
                  <label className="text-sm font-medium text-gray-700" data-id="element-3680">
                    Platform <span className="text-red-500" data-id="element-3681">*</span>
                  </label>
                  <Select data-id="element-3682">
                    <option value="" data-id="element-3683">Pilih platform...</option>
                    <option value="instagram" data-id="element-3684">Instagram</option>
                    <option value="tiktok" data-id="element-3685">TikTok</option>
                    <option value="facebook" data-id="element-3686">Facebook</option>
                    <option value="twitter" data-id="element-3687">Twitter/X</option>
                    <option value="youtube" data-id="element-3688">YouTube</option>
                    <option value="other" data-id="element-3689">Lainnya</option>
                  </Select>
                </div>}

              {/* URL Input */}
              {(proofType === 'media_tayang' || proofType === 'screenshot') && <div className="space-y-2" data-id="element-3690">
                  <label className="text-sm font-medium text-gray-700" data-id="element-3691">
                    URL/Link (Opsional)
                  </label>
                  <div className="flex gap-2" data-id="element-3692">
                    <Input placeholder="https://..." className="flex-1" data-id="element-3693" />
                    <Button variant="outline" size="icon" data-id="element-3694">
                      <LinkIcon className="h-4 w-4" data-id="element-3695" />
                    </Button>
                  </div>
                </div>}

              {/* Date & Location */}
              <div className="grid grid-cols-2 gap-4" data-id="element-3696">
                <div className="space-y-2" data-id="element-3697">
                  <label className="text-sm font-medium text-gray-700" data-id="element-3698">
                    Tanggal <span className="text-red-500" data-id="element-3699">*</span>
                  </label>
                  <Input type="date" data-id="element-3700" />
                </div>
                <div className="space-y-2" data-id="element-3701">
                  <label className="text-sm font-medium text-gray-700" data-id="element-3702">
                    Lokasi
                  </label>
                  <Input placeholder="Kota/Wilayah" data-id="element-3703" />
                </div>
              </div>

              {/* File Upload */}
              <div className="space-y-2" data-id="element-3704">
                <label className="text-sm font-medium text-gray-700" data-id="element-3705">
                  Upload Bukti <span className="text-red-500" data-id="element-3706">*</span>
                </label>
                <div className="border-2 border-dashed border-gray-300 rounded-xl p-6 flex flex-col items-center justify-center text-center bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer" data-id="element-3707">
                  <div className="h-12 w-12 bg-white rounded-full shadow-sm flex items-center justify-center mb-3" data-id="element-3708">
                    <Upload className="h-6 w-6 text-primary-600" data-id="element-3709" />
                  </div>
                  <p className="text-sm font-medium text-gray-900" data-id="element-3710">
                    Upload Foto/Video Bukti
                  </p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-3711">
                    JPG, PNG, MP4 (Max. 25MB)
                  </p>
                </div>
              </div>

              {/* Notes */}
              <div className="space-y-2" data-id="element-3712">
                <label className="text-sm font-medium text-gray-700" data-id="element-3713">
                  Catatan Tambahan
                </label>
                <Textarea placeholder="Informasi tambahan tentang bukti ini..." className="h-20" data-id="element-3714" />
              </div>

              {/* Submit Button */}
              <Button className="w-full h-12 bg-primary-600 hover:bg-primary-700 text-lg font-semibold" onClick={handleSubmit} disabled={isSubmitting} data-id="element-3715">
                {isSubmitting ? <>
                    <Loader2 className="h-5 w-5 mr-2 animate-spin" data-id="element-3716" />
                    Mengirim...
                  </> : <>
                    <Upload className="h-5 w-5 mr-2" data-id="element-3717" />
                    Kirim Bukti
                  </>}
              </Button>
            </div>}
        </div> : <div className="space-y-3 animate-in fade-in duration-300" data-id="element-3718">
          {/* Stats */}
          <div className="grid grid-cols-3 gap-3 mb-6" data-id="element-3719">
            <Card className="bg-green-50 border-green-100" data-id="element-3720">
              <CardContent className="p-3 text-center" data-id="element-3721">
                <p className="text-2xl font-bold text-green-700" data-id="element-3722">12</p>
                <p className="text-xs text-green-600" data-id="element-3723">Disetujui</p>
              </CardContent>
            </Card>
            <Card className="bg-yellow-50 border-yellow-100" data-id="element-3724">
              <CardContent className="p-3 text-center" data-id="element-3725">
                <p className="text-2xl font-bold text-yellow-700" data-id="element-3726">3</p>
                <p className="text-xs text-yellow-600" data-id="element-3727">Menunggu</p>
              </CardContent>
            </Card>
            <Card className="bg-red-50 border-red-100" data-id="element-3728">
              <CardContent className="p-3 text-center" data-id="element-3729">
                <p className="text-2xl font-bold text-red-700" data-id="element-3730">1</p>
                <p className="text-xs text-red-600" data-id="element-3731">Ditolak</p>
              </CardContent>
            </Card>
          </div>

          {/* History List */}
          {mockProofs.map(proof => <Card key={proof.id} className="active:bg-gray-50 transition-colors cursor-pointer" onClick={() => setSelectedProof(proof)} data-id="element-3732">
              <CardContent className="p-4" data-id="element-3733">
                <div className="flex items-start gap-3" data-id="element-3734">
                  <div className="p-2 bg-gray-100 rounded-lg" data-id="element-3735">
                    {getTypeIcon(proof.type)}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-3736">
                    <div className="flex items-start justify-between gap-2 mb-1" data-id="element-3737">
                      <h4 className="font-medium text-gray-900 text-sm line-clamp-1" data-id="element-3738">
                        {proof.title}
                      </h4>
                      {getStatusBadge(proof.status)}
                    </div>
                    <p className="text-xs text-gray-500 mb-2" data-id="element-3739">
                      {proof.program} • {proof.mediaType}
                    </p>
                    <div className="flex items-center gap-2 text-xs text-gray-400" data-id="element-3740">
                      <Calendar className="h-3 w-3" data-id="element-3741" />
                      {proof.date}
                    </div>
                    {proof.status === 'rejected' && proof.note && <div className="mt-2 p-2 bg-red-50 rounded text-xs text-red-700" data-id="element-3742">
                        <strong data-id="element-3743">Catatan:</strong> {proof.note}
                      </div>}
                  </div>
                  <ChevronRight className="h-5 w-5 text-gray-300 flex-shrink-0" data-id="element-3744" />
                </div>
              </CardContent>
            </Card>)}
        </div>}

      {/* Detail Modal */}
      <Modal isOpen={!!selectedProof} onClose={() => setSelectedProof(null)} title="Detail Bukti" size="sm" data-id="element-3745">
        {selectedProof && <div className="space-y-4" data-id="element-3746">
            <div className="flex items-center justify-between" data-id="element-3747">
              <div className="flex items-center gap-2" data-id="element-3748">
                {getTypeIcon(selectedProof.type)}
                <span className="text-sm text-gray-500 capitalize" data-id="element-3749">
                  {selectedProof.type.replace('_', ' ')}
                </span>
              </div>
              {getStatusBadge(selectedProof.status)}
            </div>

            <div data-id="element-3750">
              <h3 className="font-bold text-gray-900 mb-1" data-id="element-3751">
                {selectedProof.title}
              </h3>
              <p className="text-sm text-gray-500" data-id="element-3752">{selectedProof.program}</p>
            </div>

            <div className="aspect-video bg-gray-100 rounded-lg flex items-center justify-center border" data-id="element-3753">
              <ImageIcon className="h-12 w-12 text-gray-300" data-id="element-3754" />
            </div>

            <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-3755">
              <div data-id="element-3756">
                <p className="text-gray-500" data-id="element-3757">Jenis Media</p>
                <p className="font-medium" data-id="element-3758">{selectedProof.mediaType}</p>
              </div>
              <div data-id="element-3759">
                <p className="text-gray-500" data-id="element-3760">Tanggal</p>
                <p className="font-medium" data-id="element-3761">{selectedProof.date}</p>
              </div>
            </div>

            {selectedProof.url && <a href={selectedProof.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-primary-600 hover:underline" data-id="element-3762">
                <ExternalLink className="h-4 w-4" data-id="element-3763" />
                Buka Link
              </a>}

            {selectedProof.status === 'rejected' && selectedProof.note && <div className="p-3 bg-red-50 border border-red-100 rounded-lg" data-id="element-3764">
                <p className="text-xs font-medium text-red-800 mb-1" data-id="element-3765">
                  Alasan Penolakan:
                </p>
                <p className="text-sm text-red-700" data-id="element-3766">{selectedProof.note}</p>
                <Button size="sm" className="mt-3 w-full bg-red-600 hover:bg-red-700" data-id="element-3767">
                  Upload Ulang
                </Button>
              </div>}

            <Button variant="outline" className="w-full" onClick={() => setSelectedProof(null)} data-id="element-3768">
              Tutup
            </Button>
          </div>}
      </Modal>
    </OfficerLayout>;
}